import useIsScrollable from './useIsScrollable.web'

export default useIsScrollable
